import FooterNewsLetterForm from './footer-newsletter-form';

export default FooterNewsLetterForm;
